export default "__VITE_ASSET__CHXeDWqc__"